import { CornerData } from "api/types/sketch";
import { Vector2 } from "api/types/sketch";
import { drawCutRadiusCorner } from "./radius_corner";
import { drawCutInsideRadiusCorner } from "./inside_radius_corner";
import { drawCutNotchedCorner } from "./notched_corner";
import { drawCutClippedCorner } from "./clipped_corner";
import { drawCutDiagonalCorner } from "./diagonal_corner";
import { drawCutBumpoutCorner } from "./bumpout_corner";
import { drawCutRecessedDiagonalCorner } from "./recessed_diagonal_corner";
import { drawCutStandardCorner } from "./standard_corner";
import { RADIUS } from "values/quote";
import { INNER_RADIUS } from "values/quote";
import { NOTCH } from "values/quote";
import { BUMPOUT } from "values/quote";
import { CLIP } from "values/quote";
import { RECESSED_DIAGONAL } from "values/quote";
import { DIAGONAL } from "values/quote";

export function drawCutCorner(
    i: number,
    path: Path2D,
    corner_type: string,
    previous_location: Vector2,
    current_location: Vector2,
    next_location: Vector2,
    zoom: number,
    radius: number,
    length: number,
    depth: number
): CornerData | null {
    let corner_data: CornerData | null = null;
    if(corner_type === RADIUS){
        corner_data = drawCutRadiusCorner(
            path,
            i,
            previous_location,
            current_location,
            next_location,
            radius,
            zoom
        );
    }
    else if(corner_type === INNER_RADIUS){
        corner_data = drawCutInsideRadiusCorner(
            path,
            i,
            previous_location,
            current_location,
            next_location,
            radius,
            zoom
        );
    }
    else if(corner_type === NOTCH){
        corner_data = drawCutNotchedCorner(
            path,
            i,
            previous_location,
            current_location,
            next_location,
            length,
            depth,
            zoom
        );
    }
    else if(corner_type === CLIP){
        corner_data = drawCutClippedCorner(
            path,
            i,
            previous_location,
            current_location,
            next_location,
            length,
            zoom
        );
    }
    else if(corner_type === DIAGONAL){
        corner_data = drawCutDiagonalCorner(
            path,
            i,
            previous_location,
            current_location,
            next_location,
            length,
            zoom
        );
    }
    else if(corner_type === BUMPOUT){
        corner_data = drawCutBumpoutCorner(
            path,
            i,
            previous_location,
            current_location,
            next_location,
            length,
            depth,
            zoom
        );
    }
    else if(corner_type === RECESSED_DIAGONAL){
        corner_data = drawCutRecessedDiagonalCorner(
            path,
            i,
            previous_location,
            current_location,
            next_location,
            length,
            depth,
            zoom
        );
    }
    else{
        corner_data = drawCutStandardCorner(
            path,
            i,
            current_location
        )
    }
    corner_data.path = path;
    return corner_data;
}